import React from "react";
import "../assets/css/homeservices.css";

const services = [
  {
    icon: "bi-tools",
    title: "Sales & Installation",
    description:
      "Expert AC installation with comprehensive safety measures and professional setup.",
  },
  {
    icon: "bi-gear",
    title: "Maintenance & Repairs",
    description:
      "Regular preventive maintenance and prompt repair services for all AC brands.",
  },
  {
    icon: "bi-snow",
    title: "Custom HVAC Solutions",
    description:
      "Specialized design and planning for ventilation, ducts, and cooling requirements.",
  },
  {
    icon: "bi-stopwatch",
    title: "Timely Project Completion",
    description: "Efficient execution with dedicated professional team support.",
  },
];

const Services = () => {
  return (
    <section id="services" className="services-section py-5">
      <div className="container">
        <div className="section-header text-center mb-5">
          <h2 className="section-title fw-bold mb-3">End-to-End AC Solutions & Services</h2>
          <p className="section-description mx-auto">
            Comprehensive air conditioning solutions tailored to meet your
            specific needs with professional expertise and dedication.
          </p>
        </div>
        
        <div className="row g-4 mt-2">
          {services.map((service, index) => (
            <div key={index} className="col-md-6 col-lg-3">
              <div className="service-card h-100">
                <div className="service-icon-wrapper">
                  <i className={`bi ${service.icon}`}></i>
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-5">
          <a href="/services" className="service-btn">
            Explore Our Services
            <i className="bi bi-arrow-right ms-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;